var map = {
	"./_placeholder.svg": "VjLL",
	"./add.svg": "9+V+",
	"./backgroundTrim.svg": "5wGo",
	"./basket.svg": "6LBY",
	"./check.svg": "FbqP",
	"./close.svg": "v5TL",
	"./expand-less.svg": "S5KF",
	"./expand-more.svg": "iXDO",
	"./facebook.svg": "WTGj",
	"./free-resources-flag.svg": "fcYp",
	"./help.svg": "OOnu",
	"./instagram.svg": "yAB0",
	"./menu.svg": "9H6L",
	"./navigate-next.svg": "xDgn",
	"./navigate-previous.svg": "s0CE",
	"./pause.svg": "q8Jc",
	"./person.svg": "Zppt",
	"./play.svg": "duqV",
	"./remove.svg": "R93a",
	"./replay.svg": "xHYp",
	"./seabed.svg": "15Hi",
	"./search.svg": "+zOZ",
	"./shopping-cart.svg": "7Lfl",
	"./twitter.svg": "OPph",
	"./visibility-off.svg": "Nl2G",
	"./visibility.svg": "OZ/M",
	"./youtube.svg": "/jzQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OMOf";